import React from 'react';
import { useTranslation } from 'react-i18next';
import type { CreateQuoteFieldErrors, FormDataState } from '../../hooks/useCreateQuote';

interface ContactInfoSectionProps {
  formData: FormDataState;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
  fieldErrors: CreateQuoteFieldErrors['contact'];
  inputClass: string;
  labelClass: string;
}

export const ContactInfoSection: React.FC<ContactInfoSectionProps> = ({
  formData,
  handleChange,
  fieldErrors,
  inputClass,
  labelClass,
}) => {
  const { t } = useTranslation();
  const sectionTitleClass = "text-lg leading-none tracking-tight mb-4 text-foreground";
  const sectionId = 'contact-info-section-title';
  const RequiredMark = () => <span className="text-red-500 ml-1">*</span>;
  const renderFieldErrors = (errors: string[]) => (
    errors.length > 0 ? (
      <ul className="mt-2 space-y-1 text-sm text-destructive">
        {errors.map((error, index) => (
          <li key={`${error}-${index}`}>{t(error)}</li>
        ))}
      </ul>
    ) : null
  );


  return (
    <div role="group" aria-labelledby={sectionId}>
      <h4 id={sectionId} className={sectionTitleClass}>{t('quote.form.sections.contact')}</h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className={labelClass}>{t('quote.form.fields.contact.name')}<RequiredMark /></label>
          <input type="text" name="contact_name" className={inputClass} value={formData.contact_name} onChange={handleChange} required />
          {renderFieldErrors(fieldErrors.contact_name)}
        </div>
        <div>
          <label className={labelClass}>{t('quote.form.fields.contact.email')}<RequiredMark /></label>
          <input type="email" name="contact_email" className={inputClass} value={formData.contact_email} onChange={handleChange} required />
          {renderFieldErrors(fieldErrors.contact_email)}
        </div>
        <div>
          <label className={labelClass}>{t('quote.form.fields.contact.phone')}</label>
          <input type="tel" name="contact_phone" className={inputClass} value={formData.contact_phone} onChange={handleChange} />
        </div>
        <div>
          <label className={labelClass}>{t('quote.form.fields.contact.company')}</label>
          <input type="text" name="contact_company" className={inputClass} value={formData.contact_company} onChange={handleChange} />
        </div>
      </div>
    </div>
  );
};
